import store from "@/store";

export default function isActivatedUser({ next, router }) {
  let userStatus = store.getters["user/getCurrentUserStatus"];

  if (userStatus !== "blocked") {
    return next();
  }

  localStorage.removeItem("authtoken");
  return router.push({ name: "Blocked" });
}
